import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { StoreKeysEnum } from '../../../store/store-keys'
import { userContextReducer } from './state/user-context.reducers'
import { EffectsModule } from '@ngrx/effects'
import { UserContextEffects } from './state/user-context.effects'

@NgModule({
    imports: [
        StoreModule.forFeature(StoreKeysEnum.CommonUserContext, userContextReducer),
        EffectsModule.forFeature([UserContextEffects])
    ]
})
export class UserContextModule {}
